import React, { useState } from "react";
import { Typography } from "@mui/material";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import { MediaObject } from "../../types/MediaObject";
import { useSnackbar } from "notistack";

import ButtonLoading from "../Button/ButtonLoading";
import { FormContainer, SelectElement, useForm } from "react-hook-form-mui";
import { useCase } from "../../provider/CaseProvider";
import { getChangeFieldNameModalOptions } from "../../services/mediaObjectService";
import { useMutation } from "@tanstack/react-query";
import { updateResource } from "../../services/ReactQuery/reactQueryService";
import { requiredFieldDefaultFieldBased } from "../../services/reactHookFormValidationRules";

type CopyMediaObjectModalProps = {
  mediaObject: MediaObject;
  updateMediaObjects: Function;
  changeFieldNameOpen: boolean;
  setChangeFieldNameOpen: Function;
};

export default function ChangeFieldNameModal({
  mediaObject,
  updateMediaObjects,
  changeFieldNameOpen,
  setChangeFieldNameOpen,
}: CopyMediaObjectModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { product } = useCase();
  const updateMutation = useMutation({
    mutationFn: updateResource
  });

  const formContext = useForm({
    defaultValues: {
      fieldName: "",
    },
  });

  if (!product) {
    return null;
  }

  const fieldNameOptions = getChangeFieldNameModalOptions(product, mediaObject);

  if (fieldNameOptions.length < 1) {
    return null;
  }

  const isSingleOptionVariant = fieldNameOptions.length === 1;

  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    let snackbarMessage = "Die Markierung des Dokuments wurde geändert";
    try {
      await updateMutation.mutateAsync({
        uri: "media_objects",
        id: mediaObject.id,
        data: { fieldname: isSingleOptionVariant ? fieldNameOptions[0].id : values.fieldName },
      });
    } catch (e) {
      snackbarMessage = "Die Markierung konnte nicht geändert werden";
    }

    enqueueSnackbar(snackbarMessage, {
      variant: "custom",
      isNonInteractive: true,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
      persist: true,
    });

    updateMediaObjects();
    setIsLoading(false);
    formContext.reset();
    setChangeFieldNameOpen(false);
  };

  return (
    <LegalbirdIoModal
      title={"Markierung als außergerichtliches Schreiben"} // texts are not generic yet because its only used for one use case and pm cried me a river
      open={changeFieldNameOpen}
      handleClose={() => setChangeFieldNameOpen(false)}
    >
      <Typography>
        Durch die Markierung als außergerichtliches Schreiben wird das Dokument automatisch durch das System verwendet.
        Dies betrifft z.B. das Anhängen an die Deckungsanfrage für das gerichtliche Verfahren oder das automatische
        Verschicken an die Gegenseite.
      </Typography>
      <FormContainer formContext={formContext} onSuccess={handleSubmit}>
        {!isSingleOptionVariant && <SelectElement
            name={"fieldName"}
            label={"Markieren als:"}
            options={fieldNameOptions}
            rules={requiredFieldDefaultFieldBased}
          />
        }
        <ButtonLoading isLoading={isLoading} variant={"contained"} type={"submit"} sx={{marginTop: "1rem"}}>
          {isSingleOptionVariant ? fieldNameOptions[0].label : "Speichern"}
        </ButtonLoading>
      </FormContainer>
    </LegalbirdIoModal>
  );
}
